import { render, staticRenderFns } from "./UserDefinedGroupMain.vue?vue&type=template&id=2b1b4524"
import script from "./UserDefinedGroupMain.vue?vue&type=script&lang=js"
export * from "./UserDefinedGroupMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports